import UsernameFormContainer from './UsernameForm.container';
import UsernameForm from './UsernameForm';
export default UsernameFormContainer(UsernameForm);
